<nz-form-item class="ui-form-input" [style.margin]="hideError ? '0' : null">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
    label | localization
  }}</nz-form-label>
  <nz-form-control [nzValidateStatus]="control ?? 'success'" [nzErrorTip]="errorTip | localization">
    <nz-input-group [nzSuffix]="inputClearTpl" [class]="size">
      <input
        nz-input
        [placeholder]="placeholder | localization"
        [ngModel]="value"
        (blur)="onBlur()"
        (input)="onInput($event)"
        (keydown.enter)="onEnterPressed()"
        [disabled]="disabled"
        [mask]="maskConfig?.mask"
        [prefix]="maskConfig?.prefix ?? ''"
        [patterns]="maskConfig?.patterns"
        [showMaskTyped]="!!maskConfig?.showMaskTyped"
        [keepCharacterPositions]="!!maskConfig?.keepCharacterPositions"
        [dropSpecialCharacters]="maskConfig?.dropSpecialCharacters ?? null"
        [specialCharacters]="maskConfig?.specialCharacters ?? ''"
        [thousandSeparator]="maskConfig?.thousandSeparator ?? ''"
      />
    </nz-input-group>
  </nz-form-control>
</nz-form-item>

<ng-template #inputClearTpl>
  @if (value) {
  <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="onClear()" />
  } @if (suffixIcon) {
  <nz-icon class="ant-input-icon" [class.non-empty-value]="value" [nzType]="suffixIcon" />
  }
</ng-template>
